import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { PlatformType } from '@shared/constants/platform-types.enum';
import { Device, DeviceInfo } from '@core/capacitor-plugins/capacitor-plugins.class';

@Injectable()
export class PlatformService {
  constructor(private platform: Platform) {}

  get isAndroid(): boolean {
    return this.platform.is(PlatformType.Android);
  }

  get isIOS(): boolean {
    return this.platform.is(PlatformType.iOS);
  }

  get isMobile(): boolean {
    return window.innerWidth < 769;
  }

  get isWeb(): boolean {
    return !this.isNativePlatform;
  }

  get isNativePlatform(): boolean {
    return !!window.cordova;
  }

  async isAndroid10AndMore(): Promise<boolean> {
    const isAndroid10: boolean = await this.greaterOrEqualVersion(10);
    return this.isAndroid && isAndroid10;
  }

  async isAndroid12AndMore(): Promise<boolean> {
    const isAndroid12: boolean = await this.greaterOrEqualVersion(12);
    return this.isAndroid && isAndroid12;
  }

  get currentPlatform(): PlatformType {
    if (this.isAndroid) {
      return PlatformType.Android;
    } else if (this.isIOS) {
      return PlatformType.iOS;
    }
    return PlatformType.Web;
  }

  private async greaterOrEqualVersion(version: number): Promise<boolean> {
    const deviceCapacitor: DeviceInfo = await Device.getInfo();
    const deviceVersion = parseInt(deviceCapacitor.osVersion);
    return deviceVersion >= version;
  }

  public ready() {
    return this.platform.ready();
  }
}
